import $ from 'jquery';
import { getCookie } from '../cookies/index';

export const CodeInputLib = (() => {
	"use strict";
	return function (holder, length, processCallback) {
	  let _self = this;
	  let CODE_LENGTH = length || 6;
	  let codeManager = document.createElement("div");
	  codeManager.setAttribute(
		"style",
		`
				  position:relative;
				  font-size:0;
				  text-align:center;
				  margin:0 auto;
			  `
	  );
  
	  let inputManager = document.createElement("input");
	  inputManager.setAttribute(
		"style",
		`
			position: absolute;
			top: 0;
			left: 0;
			width: 100%;
			display: block;
			border: none;
			outline: none;
			background: transparent;
			caret-color: transparent;
			color: transparent;
			font-size: 30px;
			margin-right: 12px;
			line-height: 80px;
			height: 80px;
			max-width: 60px;
		`
	  );
  
	  let digitStyle = `
			position: relative;
			display: inline-block;
			box-sizing: border-box;
			border: 1px solid #F0F0F0;
			background-color: white;
			color: #050505;
			background-color: #F0F0F0;
			text-align: center;
			line-height: 80px;
			height: 80px;
			width: 100%;
			max-width: 60px;
			margin: 0 7px;
			cursor: text;
			font-size: 30px;
			vertical-align:top;
			margin-bottom: 12px;
		  `;
	  let digits = [];
	  for (let $i = 0; $i < CODE_LENGTH; $i++) {
		let digit = document.createElement("div");
		digit.setAttribute("style", digitStyle);
		digit.setAttribute(
		  "name",
		  `__${Math.ceil(Math.random() * 1000000)}__${Math.ceil(
			Math.random() * 1000000
		  )}__${Math.ceil(Math.random() * 1000000)}__${Math.ceil(
			Math.random() * 1000000
		  )}__`
		);
		digits.push(digit);
		codeManager.appendChild(digit);
	  }
	  codeManager.appendChild(inputManager);
	  _self.verification_code = "";
	  _self.instance = codeManager;
  
	  const reg = /^\d+$/;
	  const captureStroke = (e) => {
		if (!e.key) return;
  
		if (
		  e.key.toLowerCase() == "backspace" ||
		  e.key.toLowerCase() == "delete" ||
		  e.keyCode == 8 ||
		  e.keyCode == 46
		) {
			if (_self.verification_code.length > 0) {
				_self.verification_code = _self.verification_code.substr(0, _self.verification_code.length - 1);
				applyDigits();
				return;
		  	}
		}
  
		if (e.keyCode == 13) {
			processCallback();
		}
	  };
	  _self.applyError = () => {
		digits.forEach((digit) => {
		  digit.style.color = "#C0542E";
		  digit.style.borderColor = "#EC693B";
		  digit.style.backgroundColor = "#FFCEBC";
		});
	  };
	  const applyDigits = () => {
		digits.forEach((digit, i) => {
		  digit.style.color = "#050505";
		  digit.style.borderColor = "#BBBBBB";
		  digit.style.backgroundColor = "#FFF";
  
		  if (_self.verification_code.length > i) {
			digit.innerText = _self.verification_code.substr(i, 1);
		  } else {
			digit.innerText = "";
		  }
		});
		inputManager.value = "";
	  };
	  const pasteValue = () => {
		setTimeout(() => {
		  let pasted_value = inputManager.value;
		  if (reg.test(pasted_value)) {
			pasted_value = pasted_value.substr(0, CODE_LENGTH);
			_self.verification_code = pasted_value;
			applyDigits();
		  } else {
			inputManager.value = "";
		  }
		}, 5);
	  };
	  const focusInput = () => {
		inputManager.focus();
	  };
  
	  let checkTimer = 0;
	  const valueCheck = () => {
		if (inputManager.value != "") {
			inputManager.style.zIndex = "-1";
		} else {
			inputManager.style.zIndex = "auto";
			return;
		}
		inputManager.value = inputManager.value.replace(/\D/g, "").substr(0, CODE_LENGTH);
		let count = inputManager.value.length;
  
		if (inputManager.value != "") {
			let pasted_value = inputManager.value;
			if (pasted_value.length < CODE_LENGTH) {
				pasted_value = _self.verification_code + pasted_value;
			}
			pasted_value = pasted_value.substr(0, CODE_LENGTH);
			if (reg.test(pasted_value)) {
				_self.verification_code = pasted_value;
				applyDigits();
			}
	
			if (count >= CODE_LENGTH) {
				processCallback();
			}
		}
		inputManager.value = "";
	  };
  
	  holder.appendChild(codeManager);
	  document.addEventListener("click", focusInput);
	  document.addEventListener("keydown", captureStroke);
	  setTimeout(focusInput, 100);
	  setTimeout(focusInput, 1500);
	  checkTimer = setInterval(valueCheck, 150);
  
	  _self.destroy = () => {
		document.removeEventListener("click", focusInput);
		document.removeEventListener("keydown", captureStroke);
		inputManager.removeEventListener("paste", pasteValue);
		clearInterval(checkTimer);
		try {
		  holder.removeChild(codeManager);
		} catch {
		  codeManager = null;
		}
		codeManager = null;
		_self = null;
	  };
	};
})();

window.CodeInputLib = CodeInputLib;

export default () => {
	let codeForm = $('#code-form');
	let codeInput = null;

	const submitLoginForm = function() {
		let formData = new FormData();
		formData.append('email', $('#send-code', codeForm).data('email'));
		formData.append('otpNumber', codeInput.verification_code);
		$('#warning-message').hide();
		$('body').addClass('loading');
		fetch('/actions/strawberry-module/default/login-with-otp', {
			method: 'POST',
			headers: {'accept': 'application/json'}, 
			body: formData
			}).then(res => res.json()).then(response => { 
				console.log(response)
				$('body').removeClass('loading');
				if(response.response === true) {
					let chosenType = getCookie("coursePublicType");
					// if(chosenType === "bedrift") {
					// 	let data = JSON.parse(response.data);
					// 	if(data.fromEmail !== undefined) {
					// 		window.location.href = `/bestill?e=${data.fromEmail}&t=${data.Telephone}&n=${data.fromName}&l=${data.fromLastName}`;
					// 	} else {
					// 		window.location.href = `/bestill`;
					// 	}
					// } else {
					// 	window.location.href = '/shop/checkout/payment';
					// }
					let data = JSON.parse(response.data);
					if(data.fromEmail !== undefined) {
						window.location.href = `/bestill?e=${data.fromEmail}&t=${data.Telephone}&n=${data.fromName}&l=${data.fromLastName}`;
					} else {
						window.location.href = `/bestill`;
					}
				} else {
					$('#warning-message').show();
					$('body').removeClass('loading');
				}
		}).catch((error) => {
			$('body').removeClass('loading');
			console.log(error);
		});
	};

	if(codeForm.length) {
		$('button', codeForm).on('click', function(e) {
			e.preventDefault();
			submitLoginForm();
		});
		
		$('#send-code', codeForm).on('click', function(e) {
			e.preventDefault();
			codeInput.destroy();
			codeInput = new CodeInputLib($('#code-form .field')[0], 8, function() {
				console.log(codeInput.codeManager, codeInput.verification_code);
				submitLoginForm();
			});
			submitEmailCodeForm($(this).data('email'), function(){
				console.log('here')
			});
		});
		
		codeInput = new CodeInputLib($('#code-form .field')[0], 8, function() {
			console.log(codeInput.verification_code);
			submitLoginForm();
		});
	}
	
};